import { Tooltip } from "flowbite-react";
import moment from "moment";
import { cloneElement } from "react";
const DtCell = {
  Text: ({ data, cellDef }) => {
    const textStyle = {
      fontSize:
        cellDef.fontSize ||
        (cellDef.fontSizeField ? data[cellDef.fontSizeField] : ""),
      color:
        cellDef.color || (cellDef.colorField ? data[cellDef.colorField] : ""),
      textTransform:
        cellDef.textTransform ||
        (cellDef.textTransformField ? data[cellDef.textTransformField] : ""),
    };
    const displayData = cellDef.formatText
      ? cellDef.formatText(data[cellDef.key], data)
      : data[cellDef.key] || cellDef.emptyValue || "---";

    return (
      <td
        onClick={(e) => {
          e.stopPropagation();
          if (cellDef.onCellClick)
            cellDef.onCellClick({
              value: data[cellDef.key],
              displayValue: displayData,
              row: data,
            });
        }}
        className={`
        ${cellDef.width ? `w-${cellDef.width}` : ""}
        ${
          (cellDef.processClassName &&
            cellDef.processClassName(data[cellDef.key], data)) ||
          cellDef.className ||
          ""
        } ${cellDef.onCellClick ? "cursor-pointer" : ""} ${
          cellDef.onCellClick
            ? "text-indigo-500 font-medium underline"
            : "text-gray-700"
        } [&>div]:w-auto [&>div]:whitespace-nowrap [&>div]:text-ellipsis py-4 pl-4 pr-3 text-sm sm:pl-0 [&>div]:overflow-hidden`}
        style={textStyle}
      >
        <Tooltip content={displayData}>{displayData}</Tooltip>
      </td>
    );
  },
  Date: ({ data, cellDef }) => {
    const textStyle = {
      fontSize:
        cellDef.fontSize ||
        (cellDef.fontSizeField ? data[cellDef.fontSizeField] : ""),
      color:
        cellDef.color || (cellDef.colorField ? data[cellDef.colorField] : ""),
      textTransform:
        cellDef.textTransform ||
        (cellDef.textTransformField ? data[cellDef.textTransformField] : ""),
    };
    const displayData = moment(data[cellDef.key]).isValid()
      ? moment(data[cellDef.key]).format(cellDef.dateFormat)
      : cellDef.emptyValue || "---";
    return (
      <td
        onClick={(e) => {
          e.stopPropagation();
          if (cellDef.onCellClick)
            cellDef.onCellClick({
              value: data[cellDef.key],
              displayValue: displayData,
              row: data,
            });
        }}
        className={`${
          (cellDef.processClassName &&
            cellDef.processClassName(data[cellDef.key], data)) ||
          cellDef.className ||
          ""
        } ${
          cellDef.onCellClick ? "cursor-pointer" : ""
        } whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-700 sm:pl-0`}
        style={textStyle}
      >
        {displayData}
      </td>
    );
  },
  Actions: ({ data, cellDef, dtState }) => {
    return (
      <td
        className={`align-middle whitespace-nowrap py-2 px-0 text-sm sm:pl-0`}
      >
        <div
          className={`flex flex-row items-center ${
            cellDef.align && "justify-" + cellDef.align
          } flex-nowrap`}
        >
          {cellDef.actions?.map((action) => (
            <span
              key={`actions-uid-${Math.random()}`}
              className={`${action.className} text-blue-500 mr-2 cursor-pointer`}
              style={{ color: action.color }}
              onClick={(e) => {
                e.stopPropagation();
                if (action.action) action.action(data);
              }}
            >
              {action.name ||
                action.icon ||
                cloneElement(action.element, {
                  ...action.element.props,
                  data: data,
                  params: dtState,
                })}
            </span>
          ))}
        </div>
      </td>
    );
  },
  Custom: ({ data, cellDef }) => {
    return (
      <td
        onClick={(e) => {
          e.stopPropagation();
          if (cellDef.onCellClick)
            cellDef.onCellClick({
              value: data[cellDef.key],
              row: data,
            });
        }}
        className={`
        ${cellDef.width ? `w-${cellDef.width}` : ""}
        ${
          (cellDef.processClassName &&
            cellDef.processClassName(data[cellDef.key], data)) ||
          cellDef.className ||
          ""
        } ${cellDef.onCellClick ? "cursor-pointer" : ""} ${
          cellDef.onCellClick
            ? "text-indigo-500 font-medium underline"
            : "text-gray-700"
        } [&>div]:w-auto [&>div]:whitespace-nowrap [&>div]:text-ellipsis py-4 pl-4 pr-3 text-sm sm:pl-0 [&>div]:overflow-hidden`}
      >
        {cellDef.element && cloneElement(cellDef.element, {
          ...cellDef.element.props,
          data: data,
        })}
      </td>
    );
  },
};

export default DtCell;
